import type { Site, Vehicle } from "@fts/core";
import { StatusBadge } from "../components/ui";
import { useI18n } from "../i18n";
import { vehicleStatus } from "../lib/fleet";

export function VehicleTable({ vehicles, sites, showSite = false }: { vehicles: Vehicle[]; sites: Site[]; showSite?: boolean }) {
  const { t, locale } = useI18n();
  const siteName = (id: string) => sites.find((s) => s.id === id)?.name ?? t("common.empty");
  const sorted = [...vehicles].sort((a, b) => a.fleetNo.localeCompare(b.fleetNo, "tr", { numeric: true }));

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">{t("vehicle.fleetNo")}</th>
            <th scope="col">{t("vehicle.type")}</th>
            {showSite && <th scope="col">{t("vehicle.site")}</th>}
            <th scope="col" className="col-hide-sm">
              {t("vehicle.power")}
            </th>
            <th scope="col" className="col-hide-md">
              {t("vehicle.makeModel")}
            </th>
            <th scope="col" className="num col-hide-md">
              {t("vehicle.battery")}
            </th>
            <th scope="col" className="col-hide-sm">
              {t("vehicle.device")}
            </th>
            <th scope="col">{t("vehicle.status")}</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((v) => (
            <tr key={v.id}>
              <td>
                <a href={`#/vehicles/${encodeURIComponent(v.id)}`} className="row-link mono strong">
                  {v.fleetNo}
                </a>
              </td>
              <td>{t(`vehicleType.${v.type}`)}</td>
              {showSite && (
                <td>
                  <a href={`#/sites/${encodeURIComponent(v.siteId)}`} className="subtle-link">
                    {siteName(v.siteId)}
                  </a>
                </td>
              )}
              <td className="col-hide-sm">{t(`power.${v.power}`)}</td>
              <td className="col-hide-md">
                {[v.make, v.model].filter(Boolean).join(" · ") || t("common.empty")}
              </td>
              <td className="num mono col-hide-md">{v.batteryVoltage != null ? v.batteryVoltage.toLocaleString(locale) : t("common.empty")}</td>
              <td className="col-hide-sm">{v.deviceId ? <span className="mono">{v.deviceId}</span> : <span className="muted">{t("vehicle.noDevice")}</span>}</td>
              <td>
                <StatusBadge status={vehicleStatus(v)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
